module.exports = __webpack_public_path__ + "static/media/003.c3dda2b2.jpeg";